import React from 'react';
import { bool, shape } from 'prop-types';
import { RouteProvider } from '../router';
var convertCammelCase = function (text, glue) {
    return text.replace(/[A-Z]/g, function (letter) { return "".concat(glue).concat(letter.toLowerCase()); });
};
export var withProviders = function (Component, routeInfo) {
    var Wrapper = function (_a) {
        var data = _a.data, ctx = _a.ctx, _b = _a.globalResets, globalResets = _b === void 0 ? true : _b;
        return (React.createElement(RouteProvider, { ctx: ctx, routeInfo: routeInfo, useNativeMethods: true },
            React.createElement(Component, { data: data })));
    };
    Wrapper.defaultProps = {
        globalResets: true,
    };
    Wrapper.propTypes = {
        data: shape({}),
        globalResets: bool,
    };
    var displayName = Component.displayName;
    Wrapper.displayName = displayName;
    Wrapper.hydrateId = "mixer-exportable-".concat(convertCammelCase(displayName, '-'));
    Wrapper.storeId = "_".concat(convertCammelCase(displayName, '_').toUpperCase(), "__INITIAL__DATA__");
    return Wrapper;
};
export default withProviders;
//# sourceMappingURL=with-providers.js.map